// import cookie from '~/utils/cookie'

// 企业模块的store
export default {
  /**
   * 如果模块名称为：company
   *  state: { ... }, // this.$store.state.company.xxx
      getters: {
        isAdmin () { ... } // -> this.$store.getters['company/isAdmin']
      },
      actions: {
        login () { ... } // -> this.$store.dispatch('company/login')
      },
      mutations: {
        login () { ... } // -> this.$store.commit('company/login')
      }
   */
  // 开启命名空间
  namespaced: true,
  state: {
    // currentCompanyRole: sessionStorage.getItem('currentCompanyRole') ? JSON.parse(sessionStorage.getItem('currentCompanyRole')) : ''
    // 当前所选企业id
    currentCompanyId: '',
    // 当前所选企业名字
    currentCompanyName: '',
    // 成员在当前企业中的角色
    currentCompanyRole: '',
    // 各类下拉列表对象
    downListData: {}
  },
  mutations: {
    // 设置当前企业id
    SET_CURRENT_COMPANY_ID (state, id) {
      // 这里的 `state` 对象是模块的局部状态
      state.currentCompanyId = id
    },
    // 设置当前成员所在企业角色
    SET_CURRENT_COMPANY_ROLE (state, role) {
      // 这里的 `state` 对象是模块的局部状态
      state.currentCompanyRole = role
    },
    // 设置当前企业名字
    SET_CURRENT_COMPANY_NAME (state, name) {
      // 这里的 `state` 对象是模块的局部状态
      state.currentCompanyName = name
    },
    // 设置下拉列表数据
    SET_DOWN_LIST_DATA (state, data) {
      state.downListData = JSON.parse(JSON.stringify(data))
    }
  },
  actions: {

  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js